import React, { useEffect, useState } from "react";
import { Container, Carousel } from "react-bootstrap";
import firstSlide from "../images/music-g98d958f37_1920-copy.jpg";
import secondSlide from "../images/clarinet-g0b2364f60_1920.jpg";
import thirdSlide from "../images/guitar-g3fc5c7edd_1920-copy.jpg";
import forthSlide from "../images/violin-ga3dffc63f_1920-copy.jpg";
import magicHolidays from "../images/magicHolidays.gif";

const McCarousel = () => {

  return (
    <Container>
          <Carousel fade pause="hover">
          {/* <Carousel.Item interval={4500}>
              <img
                className="d-block w-100"
                src={happyHolidays}
                alt="Happy Holidays"
              />
            </Carousel.Item> */}
            {/* <Carousel.Item interval={7000}>
              <img
                className="d-block w-100"
                src={magicHolidays}
                alt="Magical Holidays"
              />
            </Carousel.Item> */}
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={firstSlide}
                alt="First slide"
              />
              <Carousel.Caption>
                <div
                  style={{
                    backgroundColor: "#ECECEC",
                    opacity: "0.7",
                    borderRadius: "10px",
                    width: "100%",
                  }}
                >
                  <h3>
                    <a
                      href="/local/events"
                      style={{ color: "#000000" }}
                    >
                      MCMTA Events
                    </a>
                  </h3>
                  <p style={{ color: "#000000" }}>
                    Take an opportunity to register your students to one of the
                    MCMTA events.
                  </p>
                </div>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={secondSlide}
                alt="Second slide"
              />
              <Carousel.Caption>
                <div
                  style={{
                    backgroundColor: "#ECECEC",
                    opacity: "0.7",
                    borderRadius: "10px",
                    width: "100%",
                  }}
                >
                  <h3>
                    <a
                      href="/local/teachersearch"
                      style={{ color: "#000000" }}
                    >
                      Find a Teacher
                    </a>
                  </h3>
                  <p style={{ color: "#000000" }}>
                    Search hundreds of MCMTA members, to find highly
                    professional teacher.
                  </p>
                </div>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={thirdSlide}
                alt="Second slide"
              />
              <Carousel.Caption>
                <div
                  style={{
                    backgroundColor: "#ECECEC",
                    opacity: "0.7",
                    borderRadius: "10px",
                    width: "100%",
                  }}
                >
                  <h3>
                    <a
                      href="/dynamiccontent/studentpacket"
                      style={{ color: "#000000" }}
                    >
                      Student's Packet
                    </a>
                  </h3>
                  <p style={{ color: "#000000" }}>
                    Learn about the activities for your students for this year.
                  </p>
                </div>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={forthSlide}
                alt="Second slide"
              />
              <Carousel.Caption>
                <div
                  style={{
                    backgroundColor: "#ECECEC",
                    opacity: "0.7",
                    borderRadius: "10px",
                    width: "100%",
                  }}
                >
                  <h3>
                    <a
                      href="/local/calendar"
                      style={{ color: "#000000" }}
                    >
                      Events Calendar
                    </a>
                  </h3>
                  <p style={{ color: "#000000" }}>
                    Check the event calendar for ongoing and future events.
                  </p>
                </div>
              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>
    </Container>
  );
};

export default McCarousel;
